module.exports = __webpack_public_path__ + "img/nearAmount.d9cbf960.svg";